// extracted by mini-css-extract-plugin
export default {"weather":"WeatherWidget_weather__HOh6r"};